module.exports = __webpack_public_path__ + "static/img-c1c9ccc1060b1dc7d6d2b60ec77d1f16.png";